import { Skeleton, Box } from '@mui/material';

interface FieldSkeletonWrapperProps {
    loading: boolean;
    children: React.ReactNode;
}

export function FieldSkeletonWrapper({ loading, children }: FieldSkeletonWrapperProps) {
    if (loading) {
        return (
            <Skeleton
                variant="rounded"
                height={56}
                sx={{ borderRadius: 1.5, mb: 1 }}
            />
        );
    }
    return <Box sx={{ mb: 1 }}>{children}</Box>;
}